// extracted by mini-css-extract-plugin
export default {"layout":"_1f8a8cc736 fc23ca115f _3429c5473b","h_slide":"bfd3852e40","category":"e62935e2a0 _47b9d5a8b4 _6dc8ff68e5"};